module.exports = __webpack_public_path__ + "bea3eff337a278f51d9f319fda7b2d83.png";